/**
 * The text of the mandatory field indicator.
 */
export const MANDATORYLABEL = "*";

/**
 * Value for dropdown option if nothing is selected. Generally showing for example 'Please select...'
 */
export const DROPDOWN_OPTION_VALUE_NO_SELECTION = "-1";

/**
 * Value for radio button if no value is pre-selected
 */
export const RADIO_OPTION_VALUE_NO_PRESELECTION = -1;
